/**
 * Top-of-screen banner shown only when the signed-in user is a synthetic
 * preview account (preview_mode = true on the user doc). Lets the viewer
 * exit the preview from any page.
 */
import { useAuth } from "@/contexts/AuthContext";
import { Eye, LogOut } from "lucide-react";

export default function PreviewBanner() {
  const { user, logout } = useAuth();
  if (!user?.preview_mode) return null;
  return (
    <div
      className="sticky top-0 z-40 bg-amber-50 border-b border-amber-300 text-amber-900 px-4 py-2 flex items-center justify-between gap-3 text-xs"
      data-testid="preview-banner"
    >
      <div className="inline-flex items-center gap-2 min-w-0">
        <Eye size={14} className="shrink-0" />
        <span className="truncate">
          <span className="font-semibold">Preview mode</span>
          <span className="hidden sm:inline"> — you are viewing the portal as</span>{" "}
          <span className="font-mono-data">{user.name} ({user.role})</span>.
          <span className="hidden sm:inline"> Data created here is shared with the real preview account.</span>
        </span>
      </div>
      <button
        onClick={logout}
        className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-sm border border-amber-400 hover:bg-amber-100 shrink-0"
        data-testid="btn-exit-preview"
      >
        <LogOut size={11} /> Exit preview
      </button>
    </div>
  );
}
